import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'NavButton',
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: undefined
    }
  },
  setup: function setup(__props) {
    var props = __props;
    defineComponent({
      name: 'NavButton'
    });
    return {
      __sfc: true,
      props: props,
      SIcon: SIcon
    };
  }
});